import { useState } from 'react';

export default function useVideoViewToggle(intialValue: boolean) {
  const [isEnabled, setIsEnabled] = useState<boolean>(intialValue);

  const toggleVideoViewEnabled = () => {
    setIsEnabled(current => !current);
  };

  const setVideoViewState = (value: boolean) => {
    setIsEnabled(value);
  };

  return { isEnabled, toggleVideoViewEnabled, setVideoViewState };
}
